export const LANDING_ROUTE = "/";

export const DASHBOARD_ROUTE = "/dashboard";
